export enum MarketType {
  PRIMARY_MARKET = 'PrimaryMarket',
  SECONDARY_MARKET = 'SecondaryMarket',
}
